"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UserProfile_1 = require("./UserProfile");
var createUserProfileMenu = function (userProfile) {
    return {
        key: "userProfileMenu",
        ariaLabel: "User Profile for " + userProfile.display_name,
        iconProps: {
            iconName: "Contact"
        },
        subMenuProps: {
            items: [
                {
                    key: "userProfile",
                    userProfile: userProfile,
                    onRender: function (item) {
                        return React.createElement(UserProfile_1.UserProfile, { key: item.key, userProfile: userProfile });
                    }
                }
            ]
        }
    };
};
exports.createUserProfileMenu = createUserProfileMenu;
